import { type ReactNode } from 'react'

import { ButtonRoot, ButtonText } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { type IconType } from '@/defs/icon'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'

import { LoadingMask } from '../../LoadingMask'

import styles from './FilterListItem.module.scss'

type Props = {
  icon?: IconType
  label: ReactNode
  onDelete?: () => void
  onEdit: () => void
  variant?: 'success' | 'warning'
}

export const FilterListItem = ({ icon, label, onDelete, onEdit, variant }: Props) => {
  const isNavigating = useIsNavigating()

  return (
    <div className={cn(styles.container, { styles, variant })} {...getClickawayIgnoreProps(['filter-form'])}>
      {icon && (
        <span className={styles.iconWrap}>
          <Icon name={icon} />
        </span>
      )}
      <ButtonRoot className={styles.label} onClick={onEdit}>
        {label}
      </ButtonRoot>
      <div className={styles.actions}>
        {onDelete && (
          <ButtonText aria-label={`Delete Filter - ${label}`} hover='warning' onClick={() => onDelete()}>
            <div className={styles.button}>
              <Icon name='xMark' />
            </div>
          </ButtonText>
        )}
      </div>
      <LoadingMask loading={isNavigating} />
    </div>
  )
}
